import { isActive } from '@hoopoe/shared';
import { Link } from '@tanstack/react-router';
import { RefreshCw } from 'lucide-react';
import { useActivity } from '../../lib/activity';

/** "⟳ 2 running" in the top bar keeps background work visible after navigating away (PLAN §12.5). */
export function ActivityCounter() {
  const { jobs } = useActivity();
  const running = jobs.filter(isActive).length;
  if (!running) return null;
  return (
    <Link
      to="/activity"
      className="flex items-center gap-1.5 rounded-md px-2 py-1 text-sm text-muted-foreground hover:bg-muted hover:text-foreground"
      data-testid="activity-counter"
    >
      <RefreshCw className="size-4 animate-spin [animation-duration:3s]" aria-hidden="true" />
      <span className="tabular">{running}</span> running
    </Link>
  );
}
